import { render, staticRenderFns } from "./Variables.vue?vue&type=template&id=5f71f38c&"
import script from "./Variables.vue?vue&type=script&lang=js&"
export * from "./Variables.vue?vue&type=script&lang=js&"
import style0 from "./Variables.vue?vue&type=style&index=0&id=5f71f38c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports